import IOSInfo from '../../../FrontApplet/Management/OS/IOSInfo';
import { SystemMemoryInfo } from '../../../FrontApplet/Management/OS/IOS';

export type ManagementOsRequests = ManagementOsGetInfoRequest | ManagementOsGetCpuUsageRequest | ManagementOsGetMemoryUsageRequest;

export const ManagementOsGetInfoRequest = 'sos.Monitoring.Management.Os.ManagementOsGetInfoRequest';
export interface ManagementOsGetInfoRequest {
	type: typeof ManagementOsGetInfoRequest;
}

export const ManagementOsGetInfoResult = 'sos.Monitoring.Management.Os.ManagementOsGetInfoResult';
export interface ManagementOsGetInfoResult {
	type: typeof ManagementOsGetInfoResult;
	result: IOSInfo;
}

export const ManagementOsGetCpuUsageRequest = 'sos.Monitoring.Management.Os.ManagementOsGetCpuUsageRequest';
export interface ManagementOsGetCpuUsageRequest {
	type: typeof ManagementOsGetCpuUsageRequest;
}

export const ManagementOsGetCpuUsageResult = 'sos.Monitoring.Management.Os.ManagementOsGetCpuUsageResult';
export interface ManagementOsGetCpuUsageResult {
	type: typeof ManagementOsGetCpuUsageResult;
	result: number;
}

export const ManagementOsGetMemoryUsageRequest = 'sos.Monitoring.Management.Os.ManagementOsGetMemoryUsageRequest';
export interface ManagementOsGetMemoryUsageRequest {
	type: typeof ManagementOsGetMemoryUsageRequest;
}

export const ManagementOsGetMemoryUsageResult = 'sos.Monitoring.Management.Os.ManagementOsGetMemoryUsageResult';
export interface ManagementOsGetMemoryUsageResult {
	type: typeof ManagementOsGetMemoryUsageResult;
	result: SystemMemoryInfo;
}
